import { BaseUniDriver, UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../../utils/test-utils/unidriver';
import { DATA_HOOKS } from './Header.constants';

export interface CardHeaderUniDriver extends BaseUniDriver {
  title(): Promise<string>;
  subtitle(): Promise<string>;
}

export const headerUniDriverFactory = (
  base: UniDriver,
): CardHeaderUniDriver => {
  const title = base.$(`[data-hook="${DATA_HOOKS.title}"]`);
  const subtitle = base.$(`[data-hook="${DATA_HOOKS.subtitle}"]`);

  return {
    ...baseUniDriverFactory(base),
    /** Returns title text. */
    title: () => title.text(),
    /** Returns subtitle text. */
    subtitle: () => subtitle.text(),
  };
};
